import React from 'react';
import { Tooltip } from 'reactstrap';

const phoneNumberPattern = /^(?!(\d)\(\1{3}\))(?!(\d)\2{9})(?!(\d)\3{2}.\3{3}.\3{4})(?:\(^[2-9]\d{2}\)|^[2-9]\d{2})(.?)?\d{3}\4\d{4}$/;

export default class PhoneNumber extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.state = {
            tooltipOpen: false,
            invalidInput: false,
            isPhoneNumberEmpty: props.value ? false : true
        };
    }

    componentDidMount() {
        const { setFocus, phoneNumberId } = this.props;
        if (setFocus) {
            const input = document.getElementById(phoneNumberId);
            if (input) {
                input.focus();
            }
        }
    }

    toggleTooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    isNumericInput = (event) => {
        const key = event.keyCode;
        return ((key >= 48 && key <= 57) || // Allow number line
            (key >= 96 && key <= 105) // Allow number pad
        );
    };

    isModifierKey = (event) => {
        const key = event.keyCode;
        return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
            (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
            (key > 36 && key < 41) || // Allow left, up, right, down
            (
                (event.ctrlKey === true || event.metaKey === true) &&
                (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
            )
    };

    onKeyPress = (event) => {
        if (!this.isNumericInput(event) && !this.isModifierKey(event)) {
            event.preventDefault();
        }
    };

    onKeyUp = (e) => {
        if (this.isModifierKey(e)) { return; }
        
        var formatTarget = e.target;
        const input = e.target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
        const first = input.substring(0, 3);
        const middle = input.substring(3, 6);
        const last = input.substring(6, 10);
        if (input.length > 5) {
            formatTarget.value = `${first}.${middle}.${last}`;
        } else if (input.length > 2) {
            formatTarget.value = `${first}.${middle}`;
        } else if (input.length > 0) {
            formatTarget.value = `${first}`
        }
        e.target = formatTarget;
        this.props.onChange(e, this.isValid(formatTarget.value));

        if (formatTarget.value) {
            if (this.state.isPhoneNumberEmpty) {
                this.setState({ invalidInput: false })
            }
            let isValid = this.isValid(formatTarget.value);
            if (!this.state.isPhoneNumberEmpty) {
                this.setState({ invalidInput: !isValid })
            }
        }
    }

    onChange(event) {
        const { value } = event.target;
        this.props.onChange(event, this.isValid(value));
    }

    childValidationMethod() {
        const { childValidationMethod, value } = this.props;
        if (childValidationMethod) {
            let isValid = this.isValid(value)
            childValidationMethod(isValid);
            if (!isValid) {
                this.setState({ invalidInput: true });
            }
        }
    }

    isValid(value) {
        return value && value.trim() && phoneNumberPattern.test(value);
    }

    validateOnBlur(event) {
        const { value } = event.target;
        this.props.onChange(event, this.isValid(value));
        if (this.props.required) {
            event.persist();   
            this.setState({
                isPhoneNumberEmpty: !value.trim()
            });         
            if (value) {
                var validPattern = phoneNumberPattern.test(value);
                if (validPattern) {
                    this.setState({ invalidInput: false });
                }
                else {
                    this.setState({ invalidInput: true });
                }
            }
            else {
                this.setState({ invalidInput: true });
                
            }
        }
    }

    render() {
        const { placeholder, value, phoneNumberId, required, name, id, autoFocus, disabled,
            inputErrorMsg, tooltipID, tooltipMsg, showAsInvalid
        } = this.props;
        const { isPhoneNumberEmpty } = this.state;
        const isValid = (!required && isPhoneNumberEmpty) || this.isValid(value);
        const containerClassName = (value ? " input-not-empty" : "") + (this.state.invalidInput || showAsInvalid ? " input-invalid" : "") + ((tooltipID && tooltipMsg) ? " input-append" : "");

        return (
            <div className={"il-group" + containerClassName}>
                <input type="text" id={phoneNumberId}
                    className="form-control"
                    value={value}
                    required={required}
                    name={name}
                    id={id}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    placeholder={placeholder ? placeholder : "Phone Number"} maxLength={12}
                    onKeyUp={e => this.onKeyUp(e)} onKeyDown={e => this.onKeyPress(e)}
                    onChange={e => this.onChange(e)}
                    onBlur={this.validateOnBlur}
                    title={placeholder ? "Please fill out the " + placeholder : "Please fill out the Phone Number."}
                    ref="inputElement"
                    aria-label={placeholder ? placeholder : 'Phone Number'}
                />
                {(tooltipID && tooltipMsg) && <div className="input-icon-append">
                    <span className="icon-info" id={tooltipID} />
                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleTooltip}>
                        {tooltipMsg}
                    </Tooltip>
                </div>}
                <div className="il-label" aria-hidden="true">{placeholder}</div>
                {inputErrorMsg ? <div className="input-error-msg">{inputErrorMsg}</div> : !isValid && (typeof value !== "undefined" && value) && <div className="input-error-msg">{"Please enter a valid phone number."}</div>}
            </div>
        );
    }
}